import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08e5ceb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-bar" }
const _hoisted_2 = ["value", "placeholder"]

import Icon from "@/components/icons/Icon/Icon.vue";
import { config } from "@/config";
import { IconType } from "@/types/icons";
import _ from "lodash";
import { ref } from "vue";

interface Emits {
  (e: "search", searchText: string): void;
}
interface Props {
  placeholder?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: {
    placeholder: { default: undefined }
  },
  emits: ["search"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;
const searchText = ref<string>();

const updateSearch = (e: Event) => {
  const target = e.target as HTMLInputElement;
  if (!target) {
    return;
  }
  const { value } = target;
  searchText.value = value;
  debounceSearch(value);
};

const emitSearch = (val: string) => {
  emit("search", val);
};

const debounceSearch = _.debounce(emitSearch, config.constants.DEBOUNCE_TIME);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      value: searchText.value,
      placeholder: _ctx.placeholder,
      onInput: updateSearch
    }, null, 40, _hoisted_2),
    _createVNode(Icon, {
      icon: _unref(IconType).MAGNIFY,
      class: "icon"
    }, null, 8, ["icon"])
  ]))
}
}

})